/**
 * Config data
 */
import {
    config
} from './configService';

/**
 * Price service
 */
export default {
    /**
     * Get formatted price
     *
     * @param {int|float} price
     *
     * @return {string}
     */
    getFormattedPrice(price) {
        const money = parseFloat( Math.ceil(price) ).toFixed(config.currency.precision).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        switch (config.currency.position) {
            case 'right':
                return `${money}${config.currency.symbol}`;
            case 'left_with_space':
                return `${config.currency.symbol} ${money}`;
            case 'right_with_space':
                return `${money} ${config.currency.symbol}`;
            case 'left':
            default:
                return `${config.currency.symbol}${money}`;
        }
    },
    /**
     * Get discounted price
     *
     * @param {int|float} price
     * @param {int|float} percent
     *
     * @return {string}
     */
    getDiscountedPrice(price, percent) {
        return Math.ceil(price * percent / 100);
    }
};
